// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__16ZpL","body":"App_body__ZTvxg"};